import dayjs from "dayjs";
import { toast } from "react-toastify";

export const getFileInfo = async (url) => {
  try {
    const response = await fetch(url, { method: "HEAD" });
    const contentType = response.headers.get("Content-Type");
    const contentLength = response.headers.get("Content-Length");
    console.log(contentType);

    return {
      type: contentType || "Unknown",
      size: contentLength || "Unknown",
    };
  } catch (error) {
    console.error("Error fetching file info:", error);
    return { type: "Unknown", size: "Unknown" };
  }
};

export const getFileNameFromUrl = (url) => {
  if (!url) return "Unknown";
  return url.split("/").pop().split("?")[0];
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

export const formatFileSize = (bytes) => {
  if (!bytes || isNaN(bytes)) return "Unknown";

  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(2)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(2)} MB`;
  const gb = mb / 1024;
  return `${gb.toFixed(2)} GB`;
};

export const showErrorToast = (err) => {
  const errorMsg =
    err?.data?.message ||
    err?.data?.error ||
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    "An unexpected error occurred";

  toast.error(errorMsg);
};

export const getPopUpStatus = (startDate, endDate) => {
  if (!startDate || !endDate) return "invalid";

  const start = dayjs(startDate).startOf("day");
  const end = dayjs(endDate).endOf("day");
  const now = dayjs();

  if (!start.isValid() || !end.isValid()) return "invalid";

  if (now.isBefore(start)) return "upcoming";
  if (now.isAfter(end)) return "expired";
  return "live";
};

export const formatDateTimeForInput = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const handleDownload = async (url, fileName, mimeType) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();

    const extension = mimeType?.split("/")?.[1]?.split(";")?.[0] || "file";
    const finalFileName = fileName.includes(".")
      ? fileName
      : `${fileName}.${extension}`;

    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = finalFileName;
    a.style.display = "none";

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("File download failed:", error);
  }
};
